import { Moment } from 'moment';

export enum ReturnedPurchaseFilterBy {
  issueDate = 'IssueDate',
  releaseDate = 'ReleaseDate',
}

export enum ReturnedPurchaseSituation {
  situationDebit = 'situationDebit',
  situationCredit = 'situationCredit',
}

export interface QuestReportReturnedPurchaseRequest {
  responseType: string;
  companiesIds?: string;
  filterBy: ReturnedPurchaseFilterBy;
  situationCredit: boolean;
  situationDebit: boolean;
  detailReturnedItems: boolean;
  detailUnspentCredit: boolean;
  detailSpentCredit: boolean;
  startDate: string;
  endDate: string;
}

export interface QuestReportReturnedPurchaseFormValues {
  companiesIds?: number[];
  filterBy: ReturnedPurchaseFilterBy;
  detailReturnedItems: boolean;
  situation: ReturnedPurchaseSituation[];
  detailUnspentCredit: boolean;
  detailSpentCredit: boolean;
  initialDate: Moment;
  finalDate: Moment;
}
